// extracted by mini-css-extract-plugin
export default {"wrapper":"h4-z","play":"i4-z"};